
import { useState } from 'react';
import { toast } from 'sonner';
import { testFrankApiConnection } from '@/services/frank';

export type TestResult = {
  status: 'success' | 'error' | 'none';
  message: string;
};

export const useConnectionTest = () => {
  const [isTestingConnection, setIsTestingConnection] = useState(false);
  const [lastTestResult, setLastTestResult] = useState<TestResult>({ 
    status: 'none', 
    message: '' 
  });

  const testApiConnection = async (apiUrl: string) => {
    try {
      setIsTestingConnection(true);
      setLastTestResult({ status: 'none', message: '' });
      
      // Basic validation to ensure it's a valid URL
      new URL(apiUrl);
      
      // Try to connect to the API
      const testResult = await testFrankApiConnection(apiUrl);
      
      if (testResult.ok) {
        setLastTestResult({
          status: 'success',
          message: `Successfully connected to Frank API (${testResult.statusCode} ${testResult.statusText || 'OK'})`
        });
        toast.success("Successfully connected to Frank API");
      } else {
        setLastTestResult({
          status: 'error',
          message: `Failed to connect to Frank API: ${testResult.statusCode || ''} ${testResult.statusText || 'Connection failed'}`
        });
        toast.error(`Failed to connect to Frank API: ${testResult.statusText || 'Connection failed'}`);
      }
    } catch (error) {
      console.error("Error testing Frank API connection:", error);
      setLastTestResult({
        status: 'error',
        message: error instanceof Error ? error.message : "Failed to connect to Frank API"
      });
      toast.error(error instanceof Error ? error.message : "Failed to connect to Frank API");
    } finally {
      setIsTestingConnection(false);
    }
  };

  return {
    isTestingConnection,
    lastTestResult,
    testApiConnection,
    setLastTestResult,
  };
};
